export default {
  trends: {
    title: "Tendances",
    navigation: {
      gameSummary: "Résumé du match",
    },
    tabs: {
      player: "Joueur",
      team: "Équipe",
      parlay: "Combiné",
      sgp: "SGP",
      stats: "Stats",
    },
    help: {
      title: "Tendances",
      description: "Linemate utilise ces signaux pour montrer la force et le contexte de chaque tendance.",
      items: {
        recentForm: "Taux de réussite de la forme récente",
        headToHead: "Taux de réussite face-à-face",
        homeAway: "Taux de réussite domicile et extérieur",
        starter: "Taux de réussite comme titulaire (Linemate+)",
        injuryImpact: "Impact d'une blessure d'un coéquipier (Linemate+)",
        opponentRank: "Classement défensif adverse (Linemate+)",
      },
    },
    empty: {
      noTrendsAvailable: "Aucune tendance disponible",
      clearFilters: "Effacer les filtres",
      offseasonTitle: "Hors saison actuellement",
      minimumGames: "Minimum de 3 matchs requis",
    },
    analysis: {
      title: "Analyse de tendance",
      viewProfile: "Voir le profil",
      addToMyPicks: "Ajouter à Mes choix",
      removeFromMyPicks: "Retirer de Mes choix",
      addParlayToMyPicks: "Ajouter le combiné à Mes choix",
      removeParlay: "Retirer le combiné",
      addLegToMyPicks: "Ajouter la sélection à Mes choix",
      removeLegFromMyPicks: "Retirer la sélection de Mes choix",
      sections: {
        playerForm: "Forme du joueur",
        playerPerformance: "Performance du joueur",
        teamPerformance: "Performance de l’équipe",
        teamForm: "Forme de l’équipe",
        startingLineup: "Formation partante",
        injuries: "Blessures",
        startingPitcher: "Lanceur partant",
        batterVsPitcher: "Batteur c. lanceur",
        opponentDefensiveRank: "Classement défensif adverse",
        weather: "Météo",
        lockedAdvancedTools: "Obtenez plus avec Linemate+",
        parlayLegs: "Sélections",
      },
      labels: {
        status: "Statut",
        player: "Joueur",
        type: "Type",
        viewGames: "Voir les matchs",
        quickCheckout: "Paiement rapide",
        showAll: "Tout afficher",
        close: "Fermer",
        openOnProvider: "Ouvrir sur {{provider}}",
        visitProvider: "Visiter {{provider}}",
        recentForm: "Forme récente",
        headToHead: "Face-à-face",
        location: "Lieu",
        lastFive: "5 derniers",
        asStarter: "Comme titulaire",
        startingPitcher: "Lanceur partant",
        overallRank: "Classement général",
        positionalRank: "Classement par position",
        confirmed: "Confirmé",
        expected: "Prévu",
        withoutPlayer: "Sans {{player}}",
        rankVsPosition: "Rang c. {{position}}",
        impactOn: "Impact sur {{target}}",
        defensiveRankAgainst: "Classement défensif de {{team}} ‧ {{betType}} contre",
        vsPitcher: "c. {{pitcher}}",
        atBatsSummary: "{{value}} {{stat}} en {{atBats}} présences au bâton",
        gamesSuffix: " matchs",
        noSignalsFound: "Aucun signal trouvé pour cette tendance",
        noStarterSignal: "Il n’y a aucun signal de titulaire",
        noStartingLineupsYet: "Il n’y a pas encore de formations partantes",
        noInjuryReportSignal: "Il n’y a aucun signal de rapport de blessures",
        noInjuries: "Il n’y a actuellement aucune blessure",
      },
      summaryCards: {
        recentForm: "Forme récente",
        headToHead: "Face-à-face",
        homeSplit: "Domicile",
        awaySplit: "Extérieur",
        recordGames: "{{record}} matchs",
        recordVs: "{{record}} c. {{opponent}}",
        recordAtHome: "{{record}} à domicile",
        recordAway: "{{record}} à l'extérieur",
      },
      paywall: {
        title: "Débloquez l'analyse complète de la tendance",
        body: "Voyez l'impact de chaque signal avancé.",
      },
      preview: {
        injuryImpact: "Rapport de blessures",
        opponentRank: "Classement défensif adverse",
        recordPlaceholder: "100% ⋅ 00 des 00 derniers matchs",
        opponentRankPlaceholder: "00e • Positif",
        weatherPlaceholder: "Nuageux",
      },
      weatherDirections: {
        inToOut: "De l'intérieur vers l'extérieur",
        outToRight: "De l'extérieur vers la droite",
        outToIn: "De l'extérieur vers l'intérieur",
        inFromLeft: "Entrant de la gauche",
        inFromRight: "Entrant de la droite",
        leftToRight: "De gauche à droite",
        outToLeft: "De l'extérieur vers la gauche",
        rightToLeft: "De droite à gauche",
        unknown: "Inconnu",
      },
      hints: {
        addTrendToMyPicks: "Ajoutez cette tendance à Mes choix pour placer votre pari",
        swipeToAddTrend: "Balayez vers la gauche pour ajouter rapidement une tendance à Mes choix.",
        swipeAddLabel: "Ajouter",
      },
      imageImport: {
        noPicksFound: "Aucun choix trouvé",
        noPicksBody: "Nous n'avons trouvé aucun choix correspondant dans cette image.",
        analyze: "Analyser",
      },
      gamelog: {
        title: "Gamelog",
        titleWithout: "Matchs joués sans {{name}}",
        chips: {
          last10: "10 derniers",
          headToHead: "Face-à-face",
          homeSplits: "Domicile",
          awaySplits: "Extérieur",
          versusPitcher: "c. {{pitcher}}",
        },
        headers: {
          hit: "Réussi",
          date: "Date",
          versus: "Contre",
          result: "Résultat",
          comp: "Comp",
        },
      },
    },
    stats: {
      sections: {
        records: "Fiches",
        headToHead: "Face-à-face",
        last5Games: "5 derniers matchs",
        rankings: "Classements",
        injuries: "Blessures",
        gameDetails: "Détails du match",
      },
      picker: {
        season: "Saison",
        last5: "5 derniers",
        headToHead: "Face-à-face",
      },
      rows: {
        recentForm: "5 derniers matchs",
        season: "Coupe du monde 2026",
        overall: "Général",
        home: "Domicile",
        away: "Extérieur",
      },
      rankings: {
        for: "POUR",
        against: "CONTRE",
      },
    },
  },
};
